import { Component, Input } from '@angular/core';
import {
  GreyRibbonWithShareButtonPositionEnum,
  IGreyRibbonWithShareButtonDescription,
} from './grey-ribbon-with-share-button.interfaces';

@Component({
  selector: 'ose-grey-ribbon-with-share-button',
  templateUrl: './grey-ribbon-with-share-button.component.html',
  styleUrls: ['./grey-ribbon-with-share-button.component.scss'],
})
export class GreyRibbonWithShareButtonComponent {
  @Input() customClasses: string;
  @Input() customDescription?: IGreyRibbonWithShareButtonDescription;

  defaultDescription =
    'Együtt óvjuk a környezetet, ezért az árainkat úgy kalkuláltuk, hogy a számlát e-mailben küldjük és nem postán. E-pack kedvezmény nélkül ' +
    'a havi díjak minden szolgáltatás csomag esetén egységesen automatikusan 700 Ft-al emelkednek. Az árak tartalmazzák az Általános Forgalmi Adót. A tájékoztatás nem teljeskörű.';

  get description(): string {
    if (!this.customDescription) {
      return this.defaultDescription;
    }

    switch (this.customDescription.position) {
      case GreyRibbonWithShareButtonPositionEnum.AFTER:
        return this.defaultDescription + ' ' + this.customDescription.description;
      case GreyRibbonWithShareButtonPositionEnum.BEFORE:
        return this.customDescription.description + ' ' + this.defaultDescription;
      case GreyRibbonWithShareButtonPositionEnum.REPLACE:
        return this.customDescription.description;
      default:
        return this.customDescription.description;
    }
  }
}
